// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fM4ng","mainCourses":"styles_mainCourses__3BTrI","ads":"styles_ads__VlN5q"};